import EA from '../helpers/init';

export default EA.Methods.mobileMenuHandler = ($this) => {
    const header = $this;
    const mobileMenuButton = $this.querySelector('.mobile-menu-btn');
    const mobileMenuContainer = $this.querySelector('.mobile-menu-container');
    const mobileMenuNewsletterWrap = $this.querySelector('.mobile-menu-newsletter');
    const mobileMenuDropdownTriggers = $this.querySelectorAll('.mobile-menu-link-wrap.has-submenu');
    let isExpanded = false;

    // Focus trap helper
    const focusTrap = {
        enabled: false,
        handleKeydown (event) {
            if(!focusTrap.enabled) return;
            if(event.key !== 'Tab') return;

            const focusableElements = mobileMenuContainer.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

            if(!focusableElements.length) return;

            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];

            if(event.shiftKey && document.activeElement === firstElement) {
                event.preventDefault();
                lastElement.focus();
            } else if(!event.shiftKey && document.activeElement === lastElement) {
                event.preventDefault();
                firstElement.focus();
            }
        }
    };

    document.addEventListener('keydown', focusTrap.handleKeydown);

    // Set mobile menu padding bottom to the height of the fixed newsletter
    if(mobileMenuNewsletterWrap) {
        mobileMenuContainer.style.paddingBottom = mobileMenuNewsletterWrap.offsetHeight + 'px';
    }


    // Hamburger button click handler
    mobileMenuButton.addEventListener('click', () => {
        isExpanded = !isExpanded;
        
        if(!isExpanded) {
            header.classList.remove('menu-open');
            mobileMenuButton.classList.remove('is-active');
            mobileMenuContainer.classList.remove('active');
            mobileMenuContainer.setAttribute('inert', true);
            document.body.style.overflow = 'auto';

            focusTrap.enabled = false;
        } else {
            header.classList.add('menu-open');
            mobileMenuButton.classList.add('is-active');
            mobileMenuContainer.classList.add('active');
            mobileMenuContainer.removeAttribute('inert');
            document.body.style.overflow = 'hidden';

            focusTrap.enabled = true;
            mobileMenuContainer.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').focus();
        }

        mobileMenuButton.setAttribute('aria-expanded', isExpanded);
    });

    // Mobile menu dropdown trigger click handler
    mobileMenuDropdownTriggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
            const currentlyActive = $this.querySelector('.mobile-menu-link-wrap.has-submenu.active');

            if(currentlyActive && currentlyActive !== trigger) {
                const currentlyActiveButton = currentlyActive.querySelector('.mobile-menu-link');
                const currentlyActiveDropdown = currentlyActive.querySelector('.mobile-dropdown');
                
                currentlyActive.classList.remove('active');
                currentlyActiveButton.setAttribute('aria-expanded', false);
                currentlyActiveDropdown.setAttribute('inert', true);
            }
            
            const button = trigger.querySelector('.mobile-menu-link');
            const dropdown = trigger.querySelector('.mobile-dropdown');

            if(button.getAttribute('aria-expanded') === 'true') {
                trigger.classList.remove('active');
                button.setAttribute('aria-expanded', false);
                dropdown.setAttribute('inert', true);
            } else {
                trigger.classList.add('active');
                button.setAttribute('aria-expanded', true);
                dropdown.removeAttribute('inert');
            }
        });
    });

    // Handle escape key
    document.addEventListener('keydown', (event) => {
        if(!isExpanded) return;

        if(event.key === 'Escape') {
            const openTrigger = $this.querySelector('.mobile-menu-link-wrap.has-submenu.active');

            if(openTrigger) {
                const button = openTrigger.querySelector('.mobile-menu-link');
                const dropdown = openTrigger.querySelector('.mobile-dropdown');

                openTrigger.classList.remove('active');
                button.setAttribute('aria-expanded', false);
                dropdown.setAttribute('inert', true);

                button.focus();

                return;
            }

            mobileMenuButton.click();
            mobileMenuButton.focus();
        }
    });
};